import { useContext, useRef, useState } from "react";

// stlyes
import Style from "./AdminDashboardNewEmploymentPositions.module.css";

// context
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
import formatNumber from "../../../../../utils/formatNumber";

const AdminDashboardNewEmploymentPositions = () => {
  const { selectedProject, projectEditable, setUpdateProjectData } = useContext(
    AdminDashboardContext
  );

  const [isNewPositionContainerOpen, setIsNewPositionContainerOpen] =
    useState(false);
  const [error, setError] = useState("");
  const nameRef = useRef(null);
  const salaryRef = useRef(null);
  const percentageRef = useRef(null);
  const workDurationRef = useRef(null);

  const [editingPositionIndex, setEditingPositionIndex] = useState(null);
  const editNameRef = useRef(null);
  const editSalaryRef = useRef(null);
  const editPercentageRef = useRef(null);
  const editWorkDurationRef = useRef(null);

  const deletePosition = (position) => () => {
    const newPositions = selectedProject.newEmploymentPositions.filter(
      (member) => member !== position
    );

    selectedProject.newEmploymentPositions = newPositions;
    setUpdateProjectData((prevState) => ({
      ...prevState,
      newEmploymentPositions: newPositions,
    }));
  };

  const startEditing = (index) => {
    setEditingPositionIndex(index);
  };

  const cancelEditing = () => {
    setEditingPositionIndex(null);
    setError("");
  };

  const saveEditedPosition = (index) => {
    const name = editNameRef.current.value;
    const salary = editSalaryRef.current.value;
    const percentage = editPercentageRef.current.value;
    const workDuration = editWorkDurationRef.current.value;

    if (!name || !salary || !percentage || !workDuration) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (percentage <= 100 && percentage > 0) {
      const updatedPositions = [...selectedProject.newEmploymentPositions];
      updatedPositions[index] = {
        positionName: name,
        positionSalary: Number(salary),
        positionPercentage: Number(percentage),
        expectedWorkTimeDurationInMonths: Number(workDuration),
      };

      selectedProject.newEmploymentPositions = updatedPositions;
      setUpdateProjectData((prevState) => ({
        ...prevState,
        newEmploymentPositions: updatedPositions,
      }));

      setEditingPositionIndex(null);
      setError("");
    } else {
      setError("Postotak radnog vremena mora biti između 0 i 100.");
    }
  };

  const addNewPosition = () => {
    const name = nameRef.current.value;
    const salary = salaryRef.current.value;
    const percentage = percentageRef.current.value;
    const workDuration = workDurationRef.current.value;

    if (!name || !salary || !percentage || !workDuration) {
      setError("Sva polja moraju biti popunjena.");
      return;
    }

    if (percentage <= 100 && percentage > 0) {
      const newPositions = selectedProject.newEmploymentPositions;
      newPositions.push({
        positionName: name,
        positionSalary: salary,
        positionPercentage: percentage,
        expectedWorkTimeDurationInMonths: workDuration,
      });

      selectedProject.newEmploymentPositions = newPositions;
      setUpdateProjectData((prevState) => ({
        ...prevState,
        newEmploymentPositions: newPositions,
      }));

      setIsNewPositionContainerOpen(false);
      setError("");
    } else {
      setError("Postotak radnog vremena mora biti veći ili jednak od nula.");
    }
  };

  return (
    <div className={Style.NewEmploymentPositionsContainer}>
      <div style={{ fontWeight: "700", color: "#5a5a5a" }}>
        POPIS NOVIH RADNIH MJESTA:
      </div>
      {selectedProject?.newEmploymentPositions?.map((member, index) => (
        <div className={Style.NewPosition} key={index}>
          {editingPositionIndex === index ? (
            <div className={Style.EditPositionForm}>
              <div className={Style.InputRow}>
                <div className={Style.NewPositionInfoTitle}>Ime: </div>
                <input
                  ref={editNameRef}
                  type="text"
                  defaultValue={member.positionName}
                  className={Style.EditInput}
                />
              </div>
              <div className={Style.InputRow}>
                <div className={Style.NewPositionInfoTitle}>Bruto 2 plaća: </div>
                <input
                  ref={editSalaryRef}
                  type="number"
                  defaultValue={member.positionSalary}
                  className={Style.EditInput}
                />
              </div>
              <div className={Style.InputRow}>
                <div className={Style.NewPositionInfoTitle}>
                  Vrijeme trajanja rada:{" "}
                </div>
                <input
                  ref={editWorkDurationRef}
                  type="number"
                  defaultValue={member.expectedWorkTimeDurationInMonths}
                  className={Style.EditInput}
                />
              </div>
              <div className={Style.InputRow}>
                <div className={Style.NewPositionInfoTitle}>
                  Postotak radnog vremena:{" "}
                </div>
                <input
                  ref={editPercentageRef}
                  type="number"
                  defaultValue={member.positionPercentage}
                  min="0"
                  max="100"
                  className={Style.EditInput}
                />
              </div>
              <div className={Style.EditButtons}>
                <button
                  className={`${Style.EditButton} ${Style.SaveButton}`}
                  onClick={() => saveEditedPosition(index)}
                >
                  Spremi
                </button>
                <button
                  className={`${Style.EditButton} ${Style.CancelButton}`}
                  onClick={cancelEditing}
                >
                  Odustani
                </button>
              </div>
            </div>
          ) : (
            <>
              {projectEditable ? (
                <div
                  className={Style.DeletePosition}
                  onClick={deletePosition(member)}
                >
                  x
                </div>
              ) : null}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={Style.NewPositionInfoTitle}>Ime: </div>
                <div className={Style.NewPositionInfo}>
                  {member.positionName}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={Style.NewPositionInfoTitle}>Bruto 2 plaća: </div>
                <div className={Style.NewPositionInfo}>
                  {formatNumber(member.positionSalary)}EUR
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={Style.NewPositionInfoTitle}>
                  Vrijeme trajanja rada:{" "}
                </div>
                <div className={Style.NewPositionInfo}>
                  {member.expectedWorkTimeDurationInMonths} mj.
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={Style.NewPositionInfoTitle}>
                  Postotak radnog vremena:{" "}
                </div>
                <div className={Style.NewPositionInfo}>
                  {member.positionPercentage}%
                </div>
              </div>
              {projectEditable && (
                <button
                  className={Style.EditPositionButton}
                  onClick={() => startEditing(index)}
                >
                  Uredi
                </button>
              )}
            </>
          )}
        </div>
      ))}
      {isNewPositionContainerOpen && (
        <div className={Style.PositionsContainer}>
          <div className={Style.InputContainer}>
            <div
              className={Style.CloseBtn}
              onClick={() => setIsNewPositionContainerOpen(false)}
            >
              &#x2715;
            </div>
            <div className={Style.InputTitle}>Naziv novog radnog mjesta</div>
            <div className={Style.ValueInputContainer}>
              <input ref={nameRef} type="text" placeholder="Ime" />
            </div>
            <div className={Style.InputTitle}>Bruto 2 plaća</div>
            <div className={Style.ValueInputContainer}>
              <input
                ref={salaryRef}
                type="number"
                placeholder="Bruto 2 plaća EUR"
              />
            </div>
            <div className={Style.InputTitle}>Vrijeme trajanja rada:</div>
            <div className={Style.ValueInputContainer}>
              <input
                ref={workDurationRef}
                type="number"
                placeholder="Vrijeme trajanja rada na projektu"
              />
            </div>
            <div className={Style.InputTitle}>Postotak radnog vremena</div>
            <div className={Style.ValueInputContainer}>
              <input
                ref={percentageRef}
                type="number"
                placeholder="Postotak radnog vremena"
                min="0"
                max="100"
              />
            </div>
            <button
              onClick={() => addNewPosition()}
              className={Style.AddNewPositionButton}
            >
              DODAJ NOVO RADNO MJESTO
            </button>
          </div>
        </div>
      )}
      {!isNewPositionContainerOpen && projectEditable && (
        <button
          className={Style.AddNewPositionButton}
          onClick={() => setIsNewPositionContainerOpen(true)}
        >
          Dodaj novog zaposlenika
        </button>
      )}
      {error && <div style={{ color: "red" }}>{error}</div>}
    </div>
  );
};

export default AdminDashboardNewEmploymentPositions;
